import { useOrdenesConjunto, type OrdenConjunto } from "./ModalOFs";
import { TypedTable } from "@/components/ui/table/TypedTable";
import { createColumnHelper, tableFeatures } from "@tanstack/react-table";
import { useMemo } from "react";
import { CommonFeatures } from "@/hooks/useTanstackTable";

export function TablaOFsModal(props: { readonly xconjunto_id: string; }) {
	const { data, error, isPending } = useOrdenesConjunto({ xconjunto_id: props.xconjunto_id });

	const { columns, features } = useMemo(() => Columns(), []);


	return (
		<TypedTable
			className="display dataTable"
			data={data ?? []}
			features={features}
			columns={columns}

			noResultsMessage="No se encontraron OFs"
			errorMessage={error?.message ?? "Error al cargar las OFs"}
			isLoading={isPending}
			isError={error != null}
		/>
	);
}

function Columns() {
	const columnHelper = createColumnHelper<typeof features, OrdenConjunto>();
	const features = tableFeatures(CommonFeatures);

	const formatter = new Intl.NumberFormat("es-ES", { style: "decimal", minimumFractionDigits: 2, maximumFractionDigits: 2 });

	const columns = columnHelper.columns([
		columnHelper.accessor("xof_id", { header: "OF" }),
		columnHelper.accessor("xcant_lanzada", {
			header: "Cantidad",
			cell: info => formatter.format(Number(info.getValue())),
		}),
		columnHelper.accessor("xfecha_lanz", { header: "Fecha lanzada" }),
	]);
	return { columns, features };
}